import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
// import styles from "../../screens/team/team.module.css";
function ConfirmDeleteDialog({ open, onClose ,handleDelete}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>

            <h2 style={{ fontFamily: 'Poppins',
    // fontStyle: "normal",
    fontWeight: 400,
    color: "#444444",
    fontSize: '20px'
    }}>Are you sure you want to delete?</h2>
            </DialogTitle>
            <DialogContent style={{textAlign:"center"}}>
            <Button onClick={handleDelete} variant="outlined" color="error" style={{
                                        fontSize: '14px',
                                        // lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        // width: 150,
                                        // height: 50,
                                        backgroundColor: "white",
                                        color: "#0F9BB0",
                                        textTransform: "none",
                                        border: "2px solid",
                                        borderColor: "#0F9BB0"
                                    }}>Yes, Delete it</Button>
                <Button onClick={onClose} style={{
                                        fontSize: '14px',
                                        // lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        // width: 150,
                                        // height: 50,
                                        backgroundColor: "white",
                                        color: "#0F9BB0",
                                        textTransform: "none",
                                        border: "2px solid",
                                        borderColor: "#0F9BB0",
                                        marginLeft: "20px"
                                     
                                    }}     >No, keep it</Button>
            </DialogContent>
            <DialogActions>
                
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteDialog;